import { FadeUp, SectionHeader } from "./Reveal.jsx";
import { useSiteContent, mediaUrl } from "@/content/ContentContext.jsx";

const SPANS = [
  "sm:col-span-2 sm:row-span-2",
  "",
  "",
  "",
  "",
  "sm:col-span-2",
  "",
  "",
];

const Gallery = () => {
  const { content } = useSiteContent();
  const c = content.gallery;

  return (
    <section id="gallery" className="relative bg-brand-tint/50 py-20 sm:py-28 lg:py-36" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-10">
        <SectionHeader eyebrow={c.eyebrow} title={c.title} lead={c.lead} testid="gallery-eyebrow" />

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-4 sm:grid-rows-[repeat(3,minmax(200px,auto))]">
          {c.images.map((img, i) => (
            <FadeUp key={img.src + i} className={SPANS[i] || ""} delay={0.04 * (i % 4)}>
              <figure
                className="group relative h-full min-h-[220px] overflow-hidden rounded-2xl"
                data-testid={`gallery-image-${i + 1}`}
              >
                <img
                  src={mediaUrl(img.src)}
                  alt={img.caption || "Farmhouse gallery image"}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-all duration-700 group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-brand-dark/0 transition-colors duration-500 group-hover:bg-brand-dark/25" />
                {img.caption && (
                  <figcaption className="absolute bottom-4 left-4 translate-y-3 rounded-full bg-white/90 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-brand opacity-0 backdrop-blur transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                    {img.caption}
                  </figcaption>
                )}
              </figure>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
